export default __webpack_public_path__ + "static/media/server-group.41b52a71.svg";